import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";

export default function NotFound() {
  const [value, setValue] = useState<string | null>("Not Found");
  const [redirect, setRedirect] = useState<string>("");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const reason = searchParams.get("reason");
    const redirectParam = searchParams.get("redirect");

    if (reason) {
      setValue(reason);
    }
    if (redirectParam) {
      setRedirect(redirectParam);
    }
  }, [searchParams]);

  return (
    <div>
      <div>{value}</div>
      {redirect ? (
        <button onClick={() => navigate(redirect, { replace: true })}>
          Try Again
        </button>
      ) : null}

      <button onClick={() => navigate("/art")}>
        Go Home
      </button>
    </div>
  );
}
